import { Status, States } from '@sift/resift/models/Status';
import { setStatus } from 'store/themes/actions/setStatus';
import fetchWithAuth from 'store/_helpers/fetchWithAuth';

export function destroyAllThemes() {
  return async dispatch => {
    try {
      dispatch(setStatus(new Status(States.LOADING)));

      const allThemesResponse = await fetchWithAuth('/api/themes');
      const allThemes = await allThemesResponse.json();

      for (const themeToDelete of allThemes) {
        if (!themeToDelete && !themeToDelete.id) continue;
        await fetchWithAuth(`/api/themes/${themeToDelete.id}`, {
          method: 'DELETE',
        });
      }

      dispatch(setStatus(new Status(States.NORMAL)));
    } catch (e) {
      dispatch(setStatus(new Status(States.ERROR)));
    }
  };
}
